import { CookieService } from 'ngx-cookie-service';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
@Injectable({
    providedIn: 'root'
})
export class CookieHandlerService {
    constructor(
        private cookieService: CookieService
    ) { }
    public SetCookie(key: string, value: any, applicationId?: any): void {
        if (!applicationId) {
            this.cookieService.set(key, value, null, '/', null, true);
        } else {
            key = applicationId + '_' + key;
            this.cookieService.set(key, value, null, '/', null, true);
        }
    }
    public GetCookie(key: string, applicationId?: string): string {
        if (!applicationId) {
            return this.cookieService.get(key);
        } else {
            return this.cookieService.get(applicationId + '_' + key);
        }
    }
    public DeleteCookies(keys: string[], applicationId?: string): void {
        if (applicationId) {
            keys.forEach((key: string, index: number) => {
                this.cookieService.delete((applicationId + '_' + key), '/');
            });
        } else {
            keys.forEach((key: string, index: number) => {
                this.cookieService.delete(key, '/');
            });
        }
    }
    public FlushAll(): void {
        this.cookieService.deleteAll();
    }

    public setPaymentDomainCookie(key: string, value: any) {
        if (environment.production) {
            this.cookieService.set(key, value, null, '/pay', '.bajajfinserv.in', true);
        } else {
            this.cookieService.set(key, value, null, '/pay', null, true);
        }
    }
}
